import React, { Component } from 'react';
import { Box, Flex, Divider } from 'rebass';
import qs from 'query-string';

import RedeemView from './components/RedeemView';
import AppContainer from '../AppContainer';
import { Text } from '../../Components/Base';
import { FONT_SIZE } from '../../Components/Theme';

export default class MockExamLinkRoute extends Component {
  handleRedeemSuccess = () => {
    this.props.history.push('/mockexam');
  };

  handleRedeemUsed = () => {
    this.props.history.push('/mockexam');
  };

  render() {
    const { menus, location } = this.props;
    let initialValue;
    if (location) {
      const { search } = location;
      const parsed = qs.parse(search);
      initialValue = parsed.code;
    }

    return (
      <AppContainer menus={menus}>
        <Box width={'100%'} mb={[2, 0]}>
          <Text fontSize={[FONT_SIZE.large]}>ผลสอบ Mock Exam</Text>
        </Box>
        <Divider borderColor="borderGrey" />
        <RedeemView
          landing
          initialValue={initialValue}
          onRedeemSuccess={this.handleRedeemSuccess}
          onRedeemUsed={this.handleRedeemUsed}
          onOverviewClick={this.handleRedeemSuccess}
        />
      </AppContainer>
    );
  }
}
